import { module } from 'stereomodularjs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.el.querySelector('select[name="Date"]').addEventListener('change', this.change.bind(this));
        this.items = this.el.querySelectorAll('[data-item]');
    }

    change(e) {
        e.preventDefault();
        const year = e.target.value;

        this.el.querySelector('[data-title]').innerHTML = 'Gagnant '+year;

        this.items.forEach(item => {
            let itemYear = item.dataset.item;
            if (itemYear == year) {
                item.style.display = null;
            } else {
                item.style.display = 'none';
            }
        });
    }

    destroy() {
        this.el.querySelector('select[name="Date"]').removeEventListener('change', this.change);
    }
}